import { css } from "@emotion/react";
export const generateCustomGlobalStyles = (themeDefault, newConfig) => {
  const onThemeChange = (value1, value2, value3) => {
    return themeDefault?.info?.themeColor === "purple"
      ? value1
      : themeDefault?.info?.themeColor === "dark"
      ? value2
      : themeDefault?.info?.themeColor === "default"
      ? value3
      : value3;
  };
  let themeValue = themeDefault?.info?.newConfig;
  return css`
    /* Global Styles */
    .ql-fill {
      fill: ${themeValue?.color}!important;
    }
    
    .ql-stroke {
      stroke: ${themeValue?.color}!important;
    }
    .ql-list,
    .ql-picker-label {
      color: ${themeValue?.color}!important;
      :hover {
        color: ${themeValue?.color}!important;
      }
    }
    .ql-editor,
    .ql-container.ql-snow {
      ::-webkit-input-placeholder {
        /* Chrome, Safari, Opera */
        color: ${themeValue?.color};
      }
.ant-btn-default:not(:disabled):not(.ant-btn-disabled):active {
    color: #a88572;
    border-color: #a88572;
     background:transparent;
}
      ::-moz-placeholder {
        /* Firefox */
        color: ${themeValue?.color};
      }

      :-ms-input-placeholder {
        /* Internet Explorer */
        color: ${themeValue?.color};
      }

      ::placeholder {
        /* Modern browsers */
        color: ${themeValue?.color};
      }

      background: transparent;
      * {
        color: ${themeValue?.color}!important;
      }
      .ql-editor.ql-blank::before {
        color: ${themeValue?.color}!important;
        opacity: 0.6;
      }
      :hover {
        background: transparent;
      }
    }
    .ql-formats {
      color: ${themeValue?.color}!important;
    }

    .ant-table-thead .ant-table-cell {
      font-family: "Exo 2";
      text-transform: uppercase;
    }

    .theme-change-text {
      color: ${themeValue?.color};
    }
    .ant-upload-wrapper {
      transition: color 0.2s ease-in-out;
      .ant-typography {
        transition: color 0.2s ease-in-out;
      }
      .p {
        transition: color 0.2s ease-in-out;
      }
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
    }
    .ant-popconfirm .ant-popconfirm-buttons button {
      width: 50px;
      height: 28px !important;
    }
    .ant-table-wrapper .ant-table-filter-trigger.active {
      .anticon {
        color: ${themeDefault?.info?.colorPrimary} !important;
      }
    }
    .ql-bubble .ql-editor::before {
      color: ${themeDefault?.info?.newConfig?.color} !important;
      font-style: italic;
    }
    .ant-upload-wrapper .ant-upload-drag:not(.ant-upload-disabled):hover,
    .ant-upload-wrapper .ant-upload-drag-hover:not(.ant-upload-disabled) {
      border-color: ${themeDefault?.info?.colorPrimary};
      color: ${themeDefault?.info?.colorPrimary};
    }.ql-toolbar.ql-snow { border:  ${
      themeDefault?.info?.newConfig?.cardborder
    };
   
}
.ql-container.ql-snow {
    border:  ${themeDefault?.info?.newConfig?.cardborder};
}
    .ant-upload-wrapper
      .ant-upload-drag:not(.ant-upload-disabled):hover
      .ant-typography,
    .ant-upload-wrapper
      .ant-upload-drag-hover:not(.ant-upload-disabled)
      .ant-typography {
      color: ${themeDefault?.info?.colorPrimary};
    }
    .theme-title-font {
      text-transform: uppercase;
      font-size: ${themeValue?.titleFontSize};
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
    }
.ant-pagination .ant-pagination-item {
    background-color: transparent; 
}
    .theme-title-popover {
      font-size: ${themeValue?.titleFontSize};
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
    }

    .theme-uppercase {
      text-transform: uppercase;
    }

    .theme-para-font-size {
      font-size: ${themeValue?.paraFontSize};
    }
      .ant-tabs .ant-tabs-tab{
.ant-typography-secondary {
     color: ${themeDefault?.info?.newConfig?.textSecondary} !important;
}
    padding: 8px 0;
    padding-top: 0px;
      }
    .ant-select-focused.ant-select-outlined:not(.ant-select-disabled):not(
        .ant-select-customize-input
      ):not(.ant-pagination-size-changer)
      .ant-select-selector {
      box-shadow: none;
    }
    .ant-picker-outlined:focus,
    .ant-picker-outlined:focus-within {
      box-shadow: none;
    }
    .theme-card-bg {
      .ant-card {
        box-shadow: none;
      }
      background: ${themeValue?.cardBackground};
    }
    .ant-input-outlined:focus,
    .ant-input-outlined:focus-within {
      box-shadow: none;
    }
    .theme-header-bg {
      background: ${themeValue?.cardBackground};
      backdrop-filter: blur(${themeValue?.cardBlur});
      border-bottom: solid 1px
        ${onThemeChange(
          "rgba(255, 255, 255, 0.14)",
          "rgba(255, 255, 255, 0.14)",
          "#f5f4f6"
        )};
      // height: 80px;
      box-shadow: none;
    }

    .theme-change-bg {
      background: ${themeValue?.cardBackground};
      box-shadow: none;
      position: sticky;
    }

    .overall-background-change {
      background-image: url(${themeValue?.dashboardBackground}) !important;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      background-attachment: fixed;
      height: 100%;
    }

    body {
      margin: 0 !important;
      font-family: ${themeDefault?.info?.fontFamily} !important;
      background: ${
        themeDefault?.info?.themeColor === "purple"
          ? "radial-gradient(circle at top, #815b72 3%,#2e1420 60%,#260a2f 109%)"
          : themeDefault?.info?.newConfig?.backgroundAccentColor
      };
      height: 100vh;
    }

    ::-webkit-scrollbar {
      width: 7px !important;
      height: 7px !important;
    }
    .ant-dropdown .ant-dropdown-menu,
    .ant-dropdown-menu-submenu .ant-dropdown-menu {
      padding: 15px;
    }
    ::-webkit-scrollbar-track {
      border: 1px solid ${themeValue?.scrollTrackBorder};
      border-radius: 0px !important;
      background: ${themeValue?.scrollTrackBg};
    }

    ::-webkit-scrollbar-thumb {
      background: ${themeValue?.scrollBarBg} !important;
      border-radius: 8px !important;
      height: 2px !important;
      width: 2px !important;
      border: 1px solid ${themeValue?.scrollBarBorder};
    }

    ::-webkit-scrollbar-thumb:hover {
      background: rgb(230, 230, 230) !important;
    }

    ::-moz-selection {
      background: ${themeValue?.cursorSelectedbg};
      color: ${themeValue?.cursorSelectedColor};
    }

    ::-webkit-selection {
      background: ${themeValue?.cursorSelectedbg};
      color: ${themeValue?.cursorSelectedColor};
    }

    ::selection {
      background: ${themeValue?.cursorSelectedbg};
      color: ${themeValue?.cursorSelectedColor};
    }

  

    .PhoneInputInput:hover {#bd99c1
      border: 1px solid ${themeDefault?.info?.colorPrimary};
    }
   .ant-radio-button-wrapper-checked:not(
        .ant-radio-button-wrapper-disabled
      ) {
      z-index: 1;
      color: #f7c2a5 !important;
      background: #f7c2a5 !important;
      border-color: #f7c2a5 !important;
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
      color: ${themeDefault?.info?.newConfig?.colorTextSecondary} !important;
    }
    .ant-tabs .ant-tabs-tab {
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
      font-size: ${themeValue?.titleFontSize};
    }
    .ant-layout,
    .ant-layout * {
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
      // font-size: ${themeValue?.titleFontSize};
    }
    .ant-slider .ant-slider-mark-text {
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
      font-size: ${themeValue?.paraFontSize};
    }
    .ant-badge-count {
      color: ${themeDefault?.info?.newConfig?.colorTextSecondary} !important;
    }

    .ant-popover-arrow {
      display: none !important;
      opacity: 0 !important;
    }

    .ant-card {
      box-shadow: ${themeDefault?.info?.newConfig?.boxShadow};
      backdrop-filter: blur(${themeValue?.cardBlur});
      font-family: ${themeDefault?.info?.fontFamily} !important;
    }

    .ant-card-bordered {
      border: 1px solid ${themeDefault?.info?.newConfig?.cardBorderColor};
    }
    .ant-card .ant-card-head-title {
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
      text-transform: uppercase;
    }

    .ant-card .ant-card-extra {
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
      font-size: ${themeValue?.paraFontSize};
    }

    .ant-menu-light,
    .ant-menu-light > .ant-menu {
      color: ${themeValue?.color};
      background: ${
        themeValue?.theme === "purple"
          ? "rgb(66 32 65 / 94%)"
          : themeValue?.theme === "default"
          ? "white"
          : themeDefault?.info?.newConfig?.backgroundAccentColor
      };
      backdrop-filter: blur(${themeValue?.cardBlur});
      border-bottom-right-radius: ${themeDefault?.info?.borderRadius}px;
      border-bottom-left-radius: ${themeDefault?.info?.borderRadius}px;
    }
   .ant-drawer .ant-drawer-footer {
    flex-shrink: 0;
    padding: 16px 16px;
    border-top: 1px solid transparent
}
.ant-collapse .ant-collapse-content {
    color: rgba(255, 255, 255, 0.85);
    background-color: transparent;
    border-top: 1px solid #bd99c1;
}
    .ant-tabs-top > .ant-tabs-nav::before,
    .ant-tabs-bottom > .ant-tabs-nav::before,
    .ant-tabs-top > div > .ant-tabs-nav::before,
    .ant-tabs-bottom > div > .ant-tabs-nav::before {
      border-bottom: ${themeDefault?.info?.newConfig?.cardborder} !important;
    }

    .ant-collapse .ant-collapse-content {

    background-color: ${themeDefault?.info?.newConfig?.collapseContentBgColor};

}
    .ant-menu-inline .ant-menu-item {
      line-height: 0px !important;
    }
    .ant-table-content {
      border-radius: 20px 20px 0 0;
    }
    .ant-picker-dropdown .ant-picker-panel-container {
      backdrop-filter: blur(${themeValue?.cardBlur});
    }

    .ant-avatar.ant-avatar-square {
      border-radius: 6px !important;
    }
    .ant-popover .ant-popover-content .ant-popover-inner {
      padding: 15px;
      margin: 0 0px;
    }

    .ant-popover .ant-popover-inner {
      backdrop-filter: blur(${themeValue?.cardBlur});
      background: transparent !important;
    }
a
    .ant-btn-default {
      background: ${
        themeValue?.theme === "default"
          ? "white"
          : themeDefault?.info?.newConfig?.backgroundAccentColor
      };
      backdrop-filter: blur(${themeValue?.cardBlur});
    }

    .ant-btn-default:hover {
      background: ${
        themeValue?.theme === "default"
          ? "white"
          : themeDefault?.info?.newConfig?.backgroundAccentColor
      };
      backdrop-filter: blur(${themeValue?.cardBlur});
    }
    .ant-tabs-dropdown .ant-tabs-dropdown-menu {
      background: ${
        themeValue?.theme === "default"
          ? "white"
          : themeDefault?.info?.newConfig?.backgroundAccentColor
      };
      backdrop-filter: blur(${themeValue?.cardBlur});
      border-radius: ${themeDefault?.info?.borderRadius / 2}px;
    }
    .ant-select-dropdown {
      background: ${
        themeValue?.theme === "default"
          ? "white"
          : themeDefault?.info?.newConfig?.backgroundAccentColor
      };
      backdrop-filter: blur(${themeValue?.cardBlur});
      border-radius: ${themeDefault?.info?.borderRadius / 2}px;
    }
      .ant-select {
      
      
      border-radius: ${themeDefault?.info?.borderRadius / 2}px;
    }

    .ant-tree {
      background: transparent;
    }

    .ant-radio:hover .ant-radio-inner,
    .ant-radio:focus .ant-radio-inner {
      border-color: ${themeDefault?.info?.colorPrimary} !important;
    }

    .ant-radio-button-wrapper-checked {
      box-shadow: none !important;
    }

    .ant-radio-button-wrapper-checked::before {
      display: none;
    }

    .ant-radio-wrapper {
      color: ${themeValue?.color} !important;
    }

    .ant-pagination .ant-pagination-item-active {
      background: ${
        themeValue?.theme === "default"
          ? "white"
          : themeDefault?.info?.newConfig?.backgroundAccentColor
      };
      backdrop-filter: blur(${themeValue?.cardBlur});
    }

    .ant-layout .ant-layout-sider {
      background: none !important;
    }

    .ant-btn-primary {
      background: ${themeDefault?.info?.colorPrimary};
    }

    .ant-btn-primary:hover {
      color: ${themeDefault?.info?.newConfig.colorTextSecondary} !important;
    }

    .ant-breadcrumb .ant-breadcrumb-separator {
      color: ${themeValue?.color} !important;
    }

    .ant-breadcrumb {
      color: ${themeValue?.breadcrumbsColor} !important;
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
    }

    .ant-breadcrumb ol {
      font-weight: 400 !important;
    }

    .ant-breadcrumb li:last-child {
      color: ${themeValue?.color} !important;
      font-weight: 500 !important;
    }

    .ant-drawer .ant-drawer-mask {
      backdrop-filter: blur(${themeValue?.backdropBlur});
    }

    .ant-modal-root .ant-modal-mask {
      backdrop-filter: blur(${themeValue?.backdropBlur});
      background: transparent;
    }

    .ant-dropdown .ant-dropdown-menu,
    .ant-dropdown-menu-submenu .ant-dropdown-menu {
      background: ${themeValue?.dropdownbg} !important;
      font-family: ${themeDefault?.info?.fontFamily} !important;
    }
    .ant-modal {
      backdrop-filter: blur(50px);
      background: transparent !important;
      padding-bottom: 0px !important;
      border-radius: ${themeDefault?.info?.borderRadius}px !important;
    }

    .ant-modal-content,
    .ant-modal-header,
    .ant-modal-footer {
      background: transparent !important;
    }
    .ant-modal-header,
    .ant-modal-title {
      border-radius: ${themeDefault?.info?.borderRadius}px !important;
    }

    .ant-typography {
      font-size: ${themeValue?.paraFontSize};
      font-family: ${themeDefault?.info?.fontFamily} !important;
    }
    .ant-btn:not(.ant-btn-primary) {
      border: 1px solid;
    }
    .ant-btn-sm {
      padding: 0px 15px;
    }
    .ant-btn-sm {
      height: 22px !important;
      padding: 0px 7px !important;
      /* border-radius: 4px; */
      font-size: 12px !important;
      font-weight: 400 !important;
      line-height: 22px;
    }
    .ant-btn {
      height: ${newConfig?.buttonHeight} !important;
      font-family: ${themeDefault?.info?.fontFamily} !important;
      font-size: ${newConfig?.btnFontSize} !important;
      padding: 4px 15px 4px 15px;
      gap: 8px;
      /* opacity: 0px; */
      font-size: 14px;
      font-weight: 400;
    }

    .ant-btn-lg {
      height: 40px;
      padding: 6.4px 15px 6.4px 15px;
      gap: 10px;
      font-weight: 400;
      font-size: 16px;
    }
    .ant-btn {
      padding-block: 0px;
      gap: clamp(4px, 0.7vw, 4px) !important;
      // height: clamp(22px, 2vw, 32px) !important;
      font-family: ${themeDefault?.info?.fontFamily} !important;
      font-size: ${newConfig?.btnFontSize} !important;
      padding-inline: 25px;
    }

    .ant-picker .ant-picker-input > input {
      font-size: ${newConfig?.btnFontSize} !important;
      font-family: ${themeValue?.fontFamily} !important;
    }
    .react-multi-email {
      height: ${newConfig?.inputHeight};
      border-radius: ${themeDefault?.info?.borderRadius}px;
      background: ${
        themeDefault?.info?.newConfig?.components?.Input?.colorBgContainer
      };
      border: ${themeDefault?.info?.newConfig?.cardborder};
      color: ${themeValue?.color};
      padding-left: 12px;
      transition: border 0.3s ease-in-out;
      curser: pointer;
    }
    .react-multi-email > input {
      background: transparent;
    }

    .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout {
      padding: 10px;
    }
    .react-multi-email:hover {
      border: 1px solid ${themeDefault?.info?.colorPrimary};
    }
    // .ant-picker-dropdown-range {
    //   max-width: 680px !important;
    // }
    // .ant-picker-dropdown {
    //   max-width: 680px !important;
    // }

    .ant-input-affix-wrapper > input.ant-input {
      height: 100% !important;
    }
    .ant-input-affix-wrapper .ant-input-prefix {
      height: 100% !important;
    }
    .ant-input-affix-wrapper .ant-input-suffix {
      height: 100% !important;
    }

  .ant-card {
    width: 100% !important;
    padding: ${
      themeDefault?.info?.borderRadius < 16
        ? 16
        : themeDefault?.info?.borderRadius
    }px ${
    themeDefault?.info?.borderRadius < 16
      ? 16 + 2
      : parseInt(themeDefault?.info?.borderRadius) + 2
  }px;

    }
    .ant-card-head {
      border: none !important;
      padding: 0px !important;
      min-height: 0px !important;
      margin-bottom: 20px !important;
    }
    .ant-card-body {
      padding: 0px !important;
    }
    .PhoneInputInput {
      height: ${newConfig?.buttonHeight};
      width: 100%;
      border-radius: ${themeDefault?.info?.borderRadius}px;
      background: ${
        themeDefault?.info?.newConfig?.components?.Input?.colorBgContainer
      };
      border: 1px solid ${
        themeDefault?.info?.newConfig?.inputBorderColor
      } !important;
      color: ${themeValue?.color};
      padding-left: 12px;
      transition: border 0.2s ease-in-out;
       &:hover {
          border: 1px solid ${themeDefault?.info?.colorPrimary} !important;
        }
    }
    .ant-input-outlined {
      min-height: ${newConfig?.buttonHeight} !important;
      font-family: ${themeDefault?.info?.fontFamily} !important;
      font-size: ${newConfig?.btnFontSize} !important;
    }

    .ant-form-item .ant-form-item-label > label {
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
      font-size: clamp(10px,.9vw,14px) !important;
    }
    [class^="ant-input"],
    [class*=" ant-input"] {
      height: ${newConfig?.buttonHeight} ;
      font-family: ${themeDefault?.info?.fontFamily} !important;
      font-size: ${newConfig?.btnFontSize} !important;
    }
    .ant-select-single .ant-select-selector {
      font-family: ${themeDefault?.info?.fontFamily} !important;
      font-size: ${newConfig?.btnFontSize} !important;
    }
    .ant-table-wrapper .ant-table-footer {
      border-radius: 0 0 40px 40px;
      margin-bottom: 20px;
    }
      .ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector {
      min-height: ${newConfig?.buttonHeight} !important;
      // height: ${newConfig?.buttonHeight} !important;
      font-family: ${themeDefault?.info?.fontFamily} !important;
      font-size: ${newConfig?.btnFontSize} !important;
}
    .ant-picker {
      height: ${newConfig?.buttonHeight} !important;
      // height: ${newConfig?.buttonHeight} !important;
      font-family: ${themeDefault?.info?.fontFamily} !important;
      font-size: ${newConfig?.btnFontSize} !important;
    }
    .ant-picker {
      height: ${newConfig?.buttonHeight} !important;
      // height: ${newConfig?.buttonHeight} !important;
      font-family: ${themeDefault?.info?.fontFamily} !important;
      font-size: ${newConfig?.btnFontSize} !important;
    }

    .ant-date-picker {
      height: ${newConfig?.buttonHeight} !important;
      // height: ${newConfig?.buttonHeight} !important;
      font-family: ${themeDefault?.info?.fontFamily} !important;
      font-size: ${newConfig?.btnFontSize} !important;
    }
    .ant-time-picker {
      height: ${newConfig?.buttonHeight} !important;
      // height: ${newConfig?.buttonHeight} !important;
      font-family: ${themeDefault?.info?.fontFamily} !important;
      font-size: ${newConfig?.btnFontSize} !important;
    }
    .ant-input-search
      > .ant-input-group
      > .ant-input-group-addon:last-child
      .ant-input-search-button:not(.ant-btn-primary) {
      height: 36px;
    }
    .ant-input-number .ant-input-number-input {
      padding: 5px 11px !important;
    }
    .ant-input-number {
      height: ${newConfig?.buttonHeight} !important;
      font-family: ${themeDefault?.info?.fontFamily} !important;
      font-size: ${newConfig?.btnFontSize} !important;
    }
    .ant-radio-button-wrapper:first-child {
      border-radius: ${themeDefault?.info?.borderRadius}px 0px 0px
        ${themeDefault?.info?.borderRadius}px;
    }
    .ant-radio-button-wrapper:last-child {
      border-radius: 0 ${themeDefault?.info?.borderRadius}px
        ${themeDefault?.info?.borderRadius}px 0;
    }
    .ant-segmented {
      // height: ${newConfig?.buttonHeight} !important;
      font-family: ${themeDefault?.info?.fontFamily} !important;
      font-size: ${newConfig?.btnFontSize} !important;
    }
      .ant-select-multiple.ant-select-sm.ant-select-show-arrow .ant-select-selector, .ant-select-multiple.ant-select-sm.ant-select-allow-clear .ant-select-selector {

      min-height: ${newConfig?.buttonHeight} !important;
}.ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
   min-height: ${newConfig?.buttonHeight} !important;
}
    .ant-select {
      min-height: ${newConfig?.buttonHeight} !important;
      font-family: ${themeDefault?.info?.fontFamily} !important;
      font-size: ${newConfig?.btnFontSize} !important;
    }

    .ant-empty-normal {
      .anticon {
        color: red !important;
      }
    }
    .ant-layout-header {
      line-height: 0px;
    }
    .ant-empty {
      font-family: ${themeDefault?.info?.fontFamily} !important;
    }
    .ant-row {
      font-family: ${themeDefault?.info?.fontFamily} !important;
    }

    .ant-col {
      font-family: ${themeDefault?.info?.fontFamily} !important;
    }

    .ant-popover {
      // z-index: 999 !important;
      font-family: ${themeDefault?.info?.fontFamily} !important;
      padding: 0px !important;
      background-color: transparent !important;
      backdrop-filter: blur(50px) !important;
      border-radius: ${themeDefault?.info?.borderRadius}px !important;
      margin: 0 0px;
    }

    .ant-tabs {
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
    }

    .ant-tabs-top > .ant-tabs-nav,
    .ant-tabs-bottom > .ant-tabs-nav,
    .ant-tabs-top > div > .ant-tabs-nav,
    .ant-tabs-bottom > div > .ant-tabs-nav {
      margin: 0 !important;
    }

    th.ant-table-cell {
      font-weight: 400 !important;
      /* line-height: 22px !important; */
      letter-spacing: 0px !important;
      text-transform: uppercase;
      padding: 16px 9px;
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
    }
      .ant-transfer .ant-transfer-list-content-item-checked {
    background-color:${themeDefault?.info?.newConfig?.tableRowHoverBg};
}.ant-transfer .ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled).ant-transfer-list-content-item-checked:hover {
    background-color:${themeDefault?.info?.newConfig?.tableRowHoverBg};
}
      .ant-transfer .ant-transfer-list-header {
  background: ${
    themeValue?.theme === "purple"
      ? "rgb(66 32 65 / 94%)"
      : themeValue?.theme === "default"
      ? "white"
      : themeDefault?.info?.newConfig?.backgroundAccentColor
  };
    transition: background-color 0.2s;
}
.ant-float-btn-default .ant-float-btn-body {
   background: ${
     themeValue?.theme === "purple"
       ? "rgb(66 32 65 / 94%)"
       : themeValue?.theme === "default"
       ? "white"
       : themeDefault?.info?.newConfig?.backgroundAccentColor
   };
    transition: background-color 0.2s;
}
.ant-input-affix-wrapper .ant-input-clear-icon {
    display: flex;
}

    .ant-float-btn {  background: ${
      themeValue?.theme === "purple"
        ? "rgb(66 32 65 / 94%)"
        : themeValue?.theme === "default"
        ? "white"
        : themeDefault?.info?.newConfig?.backgroundAccentColor
    };
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
    }

    .ant-breadcrumb {
      font-size: ${themeValue?.paraSecondaryFontSize};
    }

    .ant-tooltip .ant-tooltip-inner {
      color: ${themeValue?.color} !important;
      backdrop-filter: blur(${themeValue?.backdropBlur});
    }

    .ant-modal .ant-modal-footer {
      border-radius: 0 0 ${themeDefault?.info?.borderRadius}px
        ${themeDefault?.info?.borderRadius}px;
    }

    .ant-tooltip {
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
    }

    .ant-modal {
      font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
    }
    .ant-table-filter-dropdown-btns {
      .ant-btn:nth-child(1)::before {
        content: "Reset";
        margin-inline: 8px;
      }
      .ant-btn:nth-child(2)::before {
        content: "OK";
        margin-inline: 8px;
      }
    }
    .ant-table-filter-dropdown {
      border-radius: 8px !important;
    }
  `;
};
